export const themes = {
  text: {
    HEADING_H1_L: '48px',
    HEADING_H2_L: '36px',
    HEADING_H1_M: '36px',
    HEADING_H2_M: '24px',
    TITLE: '18px',
    TEXT_L: '16px',
    TEXT_M: '14px',
    TEXT_S: '12px',
  },
  lineHeight: {
    HEADING_H1: '56px',
    HEADING_H2: '44px',
    TITLE: '32px',
    TEXT: '28px',
  },
  colors: {
    PRIMARY_GRADIENT_FROM: '#374CB9',
    PRIMARY_GRADIENT_TO: '#2D4EF5',
    PRIMARY: 'var(--brandColor)',
    PRIMARY_LIGHT: '#2d4ef5',
    PRIMARY_DARK: '#2F4AD2',
    SUCCESS: '#4CE2A7',
    DANGER: '#E24C4C',
    WARNING: '#F1A153',
    DARK_PRIMARY: '#022047',
    TITLE: '#333333',
    TEXT: '#666666',
    GREY600: '#333333',
    GREY500: '#666666',
    GREY400: '#999999',
    GREY300: '#CCCCCC',
    GREY200: '#E5E5E5',
  },
};

export const lightThemes = {
  text: {
    HEADING_H1_L: '48px',
    HEADING_H2_L: '36px',
    HEADING_H1_M: '36px',
    HEADING_H2_M: '24px',
    TITLE: '18px',
    TEXT_L: '16px',
    TEXT_M: '14px',
    TEXT_S: '12px',
  },
  lineHeight: {
    HEADING_H1: '56px',
    HEADING_H2: '44px',
    TITLE: '32px',
    TEXT: '28px',
  },
  colors: {
    PRIMARY_GRADIENT_FROM: '#374CB9',
    PRIMARY_GRADIENT_TO: '#2D4EF5',
    PRIMARY: 'var(--brandColor)',
    PRIMARY_LIGHT: '#2d4ef5',
    PRIMARY_DARK: '#2F4AD2',
    SUCCESS: '#4CE2A7',
    DANGER: '#E24C4C',
    WARNING: '#F1A153',
    DARK_PRIMARY: '#022047',
    TITLE: '#333333',
    TEXT: '#666666',
    GREY600: '#333333',
    GREY500: '#666666',
    GREY400: '#999999',
    GREY300: '#CCCCCC',
    GREY200: '#E5E5E5',
  },
  pageBg: '#fff',
  cardBg: '#fff',
  cardInnerBg: '#f8f9fa',
  selectionBg: '#0000000d',
  txtPrimary: '#4d4d4d',
  txtSecondary: '#6c757d',
  txtIntense: '#343a40',
  txtInnerDiv: '#333333f2',
  borderColor: '#0000001a',
  inputsColor: '#242424',
};

export const darkThemes = {
  text: {
    HEADING_H1_L: '48px',
    HEADING_H2_L: '36px',
    HEADING_H1_M: '36px',
    HEADING_H2_M: '24px',
    TITLE: '18px',
    TEXT_L: '16px',
    TEXT_M: '14px',
    TEXT_S: '12px',
  },
  lineHeight: {
    HEADING_H1: '56px',
    HEADING_H2: '44px',
    TITLE: '32px',
    TEXT: '28px',
  },
  colors: {
    PRIMARY_GRADIENT_FROM: '#374CB9',
    PRIMARY_GRADIENT_TO: '#2D4EF5',
    PRIMARY: 'var(--brandColor)',
    PRIMARY_LIGHT: '#2d4ef5',
    PRIMARY_DARK: '#2F4AD2',
    SUCCESS: '#4CE2A7',
    DANGER: '#E24C4C',
    WARNING: '#F1A153',
    DARK_PRIMARY: '#022047',
    TITLE: '#333333',
    TEXT: '#666666',
    GREY600: '#333333',
    GREY500: '#666666',
    GREY400: '#999999',
    GREY300: '#CCCCCC',
    GREY200: '#E5E5E5',
  },
  pageBg: '#0f0f0f',
  cardBg: '#212020',
  cardInnerBg: '#333333f3',
  selectionBg: '#ffffff1a',
  txtPrimary: '#f1f1f1',
  txtSecondary: '#d1d1d1',
  txtIntense: '#f8f9fa',
  txtInnerDiv: '#f8f9fa',
  borderColor: '#ffffff33',
  inputsColor: '#d1d1d1',
};
